// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PoseTile_wrapper__bKHgA","main":"PoseTile_main__rfMtN","headline":"PoseTile_headline__A_r7h"};